import PropTypes from 'prop-types';
import React from 'react';
import Field from './TextArea';

export default function renderField({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);
  const id = args.id || input.name || null;

  return (
    <Field validationMessage={validationMessage} isValid={isValid} id={id} {...args} {...input} />
  );
}

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};
